// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { BiStats } from "react-icons/bi";
import ReactApexChart from 'react-apexcharts';


import './Statistics.css'

function transformToChartData(data) {
  const xCategories = []; // timestamps
  const seriesMap = new Map();

  data.forEach(gateway => {
    const gatewayName = `Gateway ${gateway.gatewayID}`;
    const points = [];

    gateway.series.forEach(point => {
      const time = point.timestamp;
      const count = point.count;

      // Add timestamp to x-axis if it's not already there
      if (!xCategories.includes(time)) {
        xCategories.push(time);
      }

      points.push({ x: time, y: count });
    });

    seriesMap.set(gatewayName, points);
  });

  return {
    series: Array.from(seriesMap.entries()).map(([name, points]) => ({
      name,
      data: points
    })),
    categories: xCategories
  };
}

function Statistics() {

  const location = useLocation();
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const { token } = location.state || {};

  // get statistics
  useEffect(() => {
    async function fetchStatistics() {
      try {   

        const response = await fetch(`${api}/series`, {
          method: "GET",
          headers: {
            "X-Api-Key": `${apiKey}`,
            "Authorization": `${token}`
          },
        });
        if (response.ok) {
          const stats = await response.json()
          console.log(stats)
          // const { series, categories } = transformToChartData(data);

          // setState(prev => ({
          //   ...prev,
          //   series,
          //   options: {
          //     ...prev.options,
          //     xaxis: {
          //       ...prev.options.xaxis,
          //       categories
          //     }
          //   }
          // }));

        } else {
          setError("Cannot fetch stats.");
        }

      } catch (err) {
        // handle empty response
        alert("network problems", err)
        return (<Navigate to="/login" />);
      }
    }
    fetchStatistics();
  }, [api, apiKey]);

  const [state, setState] = React.useState({
          
    series: [{
      name: 'Gateway 1',
      data: [3, 4, 0, 1, 10, 2, 5, 2, 1]
    }, {
      name: 'Gateway 2',
      data: [4, 5, 0, 0, 1, 1, 0, 0, 4]
    }, 
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 5,
          borderRadiusApplication: 'end'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
      },
      yaxis: {
        title: {
          text: 'SMS'
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " SMS"
          }
        }
      }
    },
  });

  return (
    <div className="page">
        <div className="header">
            <BiStats className="menu-icon" />
            <h2>Stats</h2>
        </div>
        <br></br>
        <div className='body'>
          <ReactApexChart options={state.options} series={state.series} type="bar" height={350} />
        </div>
    </div>
  );
}

export default Statistics;
